import { TemplateRef } from '@angular/core';
import { getMonth, getYear, addMonths, addYears, getDay, Locale } from 'date-fns';

import { dateFormatter } from '../../../utils';

import { HEADER_ACTION_HANDLERS, IDateUnitsInterface, labeledDateUnitType } from './types';
import { DATE_FNS_LOCALE_MAP, DATE_PICKER_MODE } from './constants';

export const headerActionHandlerMethods: Partial<Record<HEADER_ACTION_HANDLERS, Function>> = {
  [HEADER_ACTION_HANDLERS.PREV_MONTH]: (value: Date): Date => {
    return addMonths(value, -1);
  },
  [HEADER_ACTION_HANDLERS.NEXT_MONTH]: (value: Date): Date => {
    return addMonths(value, 1);
  },
  [HEADER_ACTION_HANDLERS.PREV_BUTTON]: (value: Date, mode: DATE_PICKER_MODE): Date => {
    if (!mode) return value;
    if (mode === DATE_PICKER_MODE.YEAR) return addYears(value, -10);
    else return addYears(value, -1);
  },
  [HEADER_ACTION_HANDLERS.NEXT_BUTTON]: (value: Date, mode: DATE_PICKER_MODE): Date => {
    if (!mode) return value;
    if (mode === DATE_PICKER_MODE.YEAR) return addYears(value, 10);
    else return addYears(value, 1);
  },
};

export const getLabeledDateUnits: Function = (
  value: Date,
  formats: IDateUnitsInterface,
  locale: Locale,
): labeledDateUnitType => {
  return {
    ...(formats.month && {
      month: {
        value: getMonth(value) + 1,
        label: dateFormatter(value, formats.month, locale),
      },
    }),
    ...(formats.year && {
      year: {
        value: getYear(value),
        label: dateFormatter(value, formats.year, locale),
      },
    }),
    ...(formats.day && {
      day: {
        value: getDay(value),
        label: dateFormatter(value, formats.day, locale),
      },
    }),
  };
};

export function isTemplateRefInstance(value: any): boolean {
  return value instanceof TemplateRef;
}

export function mapToDateFnsLocale(localeKey: string): Locale {
  return DATE_FNS_LOCALE_MAP[localeKey] || DATE_FNS_LOCALE_MAP.en;
}
